import { createContext, useContext, useMemo, useState } from 'react';
import { Accordion as RBAccordion } from 'react-bootstrap';

type AccordionType = [string, React.Dispatch<React.SetStateAction<string>>];
const AccordionCtx = createContext<AccordionType>(['', () => {}]);

export const useAccordion = () => useContext(AccordionCtx);

type Props = React.PropsWithChildren<{ open?: string }>;
export const Accordion = (props: Props) => {
  const { children, open } = props;

  const [visible, setVisible] = useState(open ?? '');

  const contextValue: AccordionType = useMemo(() => [visible, setVisible], [visible, setVisible]);

  return (
    <AccordionCtx.Provider value={contextValue}>
      <RBAccordion defaultActiveKey={visible}>{children}</RBAccordion>
    </AccordionCtx.Provider>
  );
};
